import InventaireStocksLeveeController from './inventaire.stocks.levee.controller';
import Template from './inventaire.stocks.levee.html';

export default {
	bindings: {
		levee: '=',
		modalInstance: '='
	},
	template: Template,
	controller: InventaireStocksLeveeController
};
